import apiService from '../../../services/api'

/**
 * Steam Topup API
 * Сервис для вывода кристаллов на Steam-аккаунт
 * Документация: docs/steam_topup.md
 *
 * Два эндпоинта:
 * - GET /api/steam-topup/ — всё для экрана (info + history)
 * - POST /api/steam-topup/ — создать заявку на вывод
 */

/**
 * Получить данные экрана вывода: info + история заявок
 * @returns {Promise<Object>} { info: {...}, history: [...] }
 */
const fetchSteamTopupData = async () => {
  const response = await apiService.makeRequest('/api/steam-topup/')
  return response
}

/**
 * Создать заявку на вывод кристаллов в Steam
 * @param {string} steamLogin — логин Steam (не SteamID)
 * @param {number} crystals — сумма в кристаллах
 * @returns {Promise<Object>} { id, usd, crystals, status }
 */
const createSteamTopup = async (steamLogin, crystals) => {
  const response = await apiService.makeRequest('/api/steam-topup/', {
    method: 'POST',
    body: JSON.stringify({
      steam_login: steamLogin,
      crystals,
    }),
  })
  return response
}

export default {
  fetchSteamTopupData,
  createSteamTopup,
}
